import React, { useRef } from "react";
import { Box, Button, IconButton, Container } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";

const CategoryBar = ({
  allCategories,
  handleSelect,
  selectedCategory,
  setPageCount,
}) => {
  const scrollRef = useRef(null);

  const filterByCategory = (category) => {
    return category?.filter((cat) => cat.parent === null);
  };

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = scrollRef.current.offsetWidth; // scroll by one "page"
      scrollRef.current.scrollBy({
        left: direction === "left" ? -scrollAmount : scrollAmount,
        behavior: "smooth",
      });
    }
  };

  const handleSelectCategory = (cat) => {
    if (selectedCategory === cat) {
      handleSelect(null);
    } else {
      // ✅ normal select
      handleSelect(cat);
    }
    setPageCount(0);
  };

  return (
    <Container maxWidth="lg">
      <Box
        sx={{
          display: "flex",
          gap: 1,
          maxWidth: "1300px",
          width: "100%",
          margin: "0 auto",

          overflowX: "auto",
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": { display: "none" },
        }}
      >
        <Box
          sx={{
            position: "relative",
            display: "flex",
            alignItems: "center",
            width: "100%",
            overflow: "hidden",
            py: 2,
          }}
        >
          {/* Left Arrow */}
          <IconButton
            size="small"
            onClick={() => scroll("left")}
            sx={{
              boxShadow: 2,
              "&:hover": { bgcolor: "grey.100" },
            }}
          >
            <ArrowBackIosNewIcon fontSize="small" />
          </IconButton>

          {/* Scrollable Category Buttons */}
          <Box
            ref={scrollRef}
            sx={{
              display: "flex",
              overflowX: "auto",
              scrollbarWidth: "none", // Firefox
              "&::-webkit-scrollbar": { display: "none" }, // Chrome/Safari
              scrollBehavior: "smooth",
              flex: 1,
              py: 1, // spacing so arrows don’t overlap text
            }}
          >
            {filterByCategory(allCategories)?.map((cat, idx) => (
              <Box
                key={idx}
                sx={{
                  flex: "0 0 15%", // 🔑 ensures exactly 5 categories visible
                  display: "flex",
                  justifyContent: "center",
                  px: 1,
                }}
              >
                <Button
                  variant="contained"
                  size="small"
                  sx={{
                    fontSize: "0.80rem",
                    bgcolor: selectedCategory === cat?.name ? "black" : "white",
                    color: selectedCategory === cat?.name ? "white" : "black",
                    borderRadius: "10px",
                    whiteSpace: "nowrap",
                    textTransform: "none",
                    width: "100%",
                    "&:hover": {
                      bgcolor:
                        selectedCategory === cat?.name ? "black" : "grey.100",
                    },
                  }}
                  onClick={() => handleSelectCategory(cat?.name)}
                >
                  {cat.name}
                </Button>
              </Box>
            ))}
          </Box>

          {/* Right Arrow */}
          <IconButton
            size="small"
            onClick={() => scroll("right")}
            sx={{
              boxShadow: 2,
              "&:hover": { bgcolor: "grey.100" },
            }}
          >
            <ArrowForwardIosIcon fontSize="small" />
          </IconButton>
        </Box>
      </Box>
    </Container>
  );
};

export default CategoryBar;

// import React, { useState } from "react";
// import { Box, Typography, Popper, Paper, Grid, Container } from "@mui/material";
// import CustomContainer from "components/Common/CustomContainer";

// const CategoryBar = ({
//   allCategories,
//   handleSelect,
//   selectedCategory,
//   setPageCount,
// }) => {
//   const [anchorEl, setAnchorEl] = useState(null);
//   const [hoverCategory, setHoverCategory] = useState(null);

//   // ✅ Top categories (parent = null)
//   const parentCategories = allCategories?.filter((cat) => cat.parent === null);

//   // ✅ Get children based on selected hover parent
//   const getChildCategories = (parentId) => {
//     return allCategories?.filter((cat) => cat.parent === parentId);
//   };

//   // Hover open dropdown
//   const handleMouseEnter = (event, category) => {
//     setAnchorEl(event.currentTarget);
//     setHoverCategory(category);
//   };

//   // Close dropdown
//   const handleClose = () => {
//     setAnchorEl(null);
//     setHoverCategory(null);
//   };

//   const open = Boolean(anchorEl);

//   // Select category on click
//   const handleSelectCategory = (catName) => {
//     if (selectedCategory === catName) {
//       handleSelect(null);
//     } else {
//       handleSelect(catName);
//     }
//     setPageCount(0);
//   };

//   return (
//     <Box
//       sx={{
//         width: "100%",
//         backgroundColor: "rgb(252 252 252 / 1)", // Tailwind bg
//         borderBottom: "1px solid rgba(0,0,0,0.12)",
//         position: "relative",
//         zIndex: 50,
//       }}
//       onMouseLeave={handleClose}
//     >
//       {/* ================== TOP NAV BAR ================== */}
//       <Container maxWidth="lg" disableGutters>
//         <Box
//           sx={{
//             display: "flex",
//             gap: 1,
//             maxWidth: "1300px",
//             width: "100%",
//             margin: "0 auto",
//             py: 1.5,
//             overflowX: "auto",
//             scrollbarWidth: "none",
//             "&::-webkit-scrollbar": { display: "none" },
//           }}
//         >
//           {parentCategories?.map((cat) => (
//             <Box
//               key={cat.id}
//               onMouseEnter={(e) => handleMouseEnter(e, cat)}
//               onClick={() => handleSelectCategory(cat.name)}
//               sx={{
//                 cursor: "pointer",
//                 px: 2,
//                 py: 1,
//                 borderRadius: "999px",
//                 fontWeight: 550,
//                 fontSize: "0.80rem",
//                 whiteSpace: "nowrap",
//                 bgcolor: selectedCategory === cat.name ? "#000" : "transparent",
//                 color: selectedCategory === cat.name ? "#fff" : "#000",
//                 transition: "0.2s",
//                 "&:hover": {
//                   bgcolor: "#000",
//                   color: "#fff",
//                 },
//               }}
//             >
//               {cat.name}
//             </Box>
//           ))}
//         </Box>
//       </Container>
//     </Box>
//   );
// };

// export default CategoryBar;
